/* eslint-disable max-len */

import { AllieIconProps } from '../../..';

export const SlashIcon: React.FC<AllieIconProps> = () => (
  <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="slash-circle-01" clipPath="url(#clip0_8643_3889)">
      <path
        id="Icon"
        d="M2.569 2.465L9.639 9.535M11.104 6C11.104 8.76142 8.86543 11 6.104 11C3.34258 11 1.104 8.76142 1.104 6C1.104 3.23858 3.34258 1 6.104 1C8.86543 1 11.104 3.23858 11.104 6Z"
        stroke="#D92D20"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_8643_3889">
        <rect width="12" height="12" fill="white" transform="translate(0.104004)" />
      </clipPath>
    </defs>
  </svg>
);
